import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { ResizeHandlerModule } from '@usitsdasdesign/dds-ng/shared/resize-handler';
import { CommonModalContainerComponent } from './common-modal-container/common-modal-container.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [ConfirmModalComponent, CommonModalContainerComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    ResizeHandlerModule
  ],
  exports: [ConfirmModalComponent, CommonModalContainerComponent]
})
export class ModalsModule { }
